/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_PrevInputs */

const vi_grower_area_camera_prev = /** @type {(inputs: Grower_Area_Camera_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera trước`)
};

/**

* @param {Grower_Area_Camera_PrevInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_prev = /** @type {((inputs?: Grower_Area_Camera_PrevInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_PrevInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_prev(inputs)
});